import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { FsBadgeModule } from '@firestitch/badge';
import { FsMenuModule } from '@firestitch/menu';
import { FsNavModule } from '@firestitch/nav';
import { FsStore } from '@firestitch/store';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { WindowMessageEventType } from '@common/enums';
import { Account, WindowMessageEvent } from '@common/interfaces';
import { WindowMessageService } from '@common/services';
import { SignoutService } from '@common/services/signout.service';

import { NotificationService } from '../../services/notification.service';

import { NotificationsMenuComponent } from './notifications-menu/notifications-menu.component';


@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,

    FsBadgeModule,
    FsMenuModule,
    FsNavModule,
  ],
})
export class AccountMenuComponent implements OnDestroy, OnInit {

  public account: Account;
  public unreadNotifications: number;

  private _signoutService = inject(SignoutService);
  private _store = inject(FsStore);
  private _notificationService = inject(NotificationService);
  private _windowMessageService = inject(WindowMessageService);
  private _cdRef = inject(ChangeDetectorRef);
  private _destroy$ = new Subject<void>();
  private _dialog = inject(MatDialog);

  public ngOnInit(): void {
    this._store.observe('account')
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((store) => {
        this.account = store.value;
      });

    this._notificationService
      .notification$
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((data) => {
        this.unreadNotifications = data;
        this._cdRef.markForCheck();
      });

    this._windowMessageService.event$
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((event: WindowMessageEvent) => {
        switch (event.type) {
          case String(WindowMessageEventType.NotificationsUnread):
            this.unreadNotifications = Number(event.data);
            this._cdRef.markForCheck();
            break;
        }
      });
  }

  public openNotifications() {
    this._dialog.open(NotificationsMenuComponent, {
      autoFocus: false,
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public signout() {
    this._signoutService.signout();
  }

}
